import t from './catalog.types';

export const setCatalogProvider = (provider: string) => ({
  type: t.CATALOG_SET_PROVIDER,
  payload: provider,
});

export const addCatalogSelectedItem = (item: any) => ({
  type: t.CATALOG_ADD_SELECTED_ITEM,
  payload: item,
});

export const removeCatalogSelectedItem = (itemId: string | number) => ({
  type: t.CATALOG_REMOVE_SELECTED_ITEM,
  payload: itemId,
});

export const clearCatalogSelectedItems = () => ({
  type: t.CATALOG_CLEAR_SELECTED_ITEMS,
});

export const setCatalogSearchQuery = (query: string) => ({
  type: t.CATALOG_SET_SEARCH_QUERY,
  payload: query,
});

export const setCatalogFilters = (filters: Record<string, any>) => ({
  type: t.CATALOG_SET_FILTERS,
  payload: filters,
});

export const resetCatalog = () => ({
  type: t.CATALOG_RESET,
});
